import React from 'react';
import NavigationBarV2 from '../../components/NavigationBarV2/NavigationBarV2';
import './View.css';

function View({section, showNavbar, showCartLink, children}) {
    const renderChildren = () => {
        return children;
    };

    return (
        <div className='view'>
            {showNavbar && <NavigationBarV2 section={section} showCartLink={showCartLink}/>}
            {renderChildren()}
        </div>
    );
}

export default View;